var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

$(document).on('change', '.byos-product-item-checkbox', function() {
  const $list = $(this).closest('.byos-product-list'); // find its own list
  const $checkboxes = $list.find('.byos-product-item-checkbox');
  const checked = $checkboxes.filter(':checked');

  // Prevent unchecking the last one in this specific list
  if (checked.length === 0) {
    $(this).prop('checked', true);

    // optional feedback
    const $label = $(this).closest('.byos-product-item').find('.byos-product-item_wrapper');
    $label.addClass('shaking');
    setTimeout(() => $label.removeClass('shaking'), 1000);
  }
});

$('.byos-product-item').each(function () {
    var $productItem = $(this);
    var $checkbox = $productItem.find('.byos-product-item-checkbox');

    if($productItem.find('.byosProductJson').length > 0){
      
      // Get product JSON
      var productData = JSON?.parse($productItem.find('.byosProductJson').text()).product;
  
      // All swatch radios inside this product
      var $swatches = $productItem.find('.byos-product-item-block-swatch__radio, .byos-product-item-color-swatch__radio');
  
      // Update variant ID
      function updateSelectedVariantId() {
          var selectedOptions = [];
  
          // Loop through each product option index
          productData.options.forEach(function(option, index) {
              var optionPosition = index + 1;
  
              // Get checked radio for this option
              var $checkedSwatch = $productItem.find('[data-option-position="' + optionPosition + '"]:checked');
  
              if ($checkedSwatch.length) {
                  // 👉 USE THE INPUT VALUE DIRECTLY
                  selectedOptions.push($checkedSwatch.val().trim());
              }
          });
  
          // Match variant
          var matchedVariant = productData.variants.find(function (variant) {
              return JSON.stringify(variant.options) === JSON.stringify(selectedOptions);
          });
  
          if (matchedVariant) {
              $checkbox.attr('selected_variant_id', matchedVariant.id);
              console.log("✔ Updated variant:", matchedVariant.id, productData.title);
          } else {
              console.log("❌ No matching variant for:", selectedOptions);
          }
      }
  
      // Run once
      updateSelectedVariantId();
  
      // Run on swatch change
      $swatches.on('change', function () {
          updateSelectedVariantId();
      });
    }
});





$(document).ready(function(){
  $('body').on('click', '.byos-atc-button', function (e) {
    e.preventDefault();
    var _this = this;
    this.setAttribute('disabled', 'disabled');
    this.setAttribute('aria-busy', 'true');

    var randomId = Math.random().toString(36).substring(2, 12);
    var items = [];

    $(this).closest('.byos-modal').find('.byos-product-item').each(function() {
      var quantity = parseInt($(this).find('[name="quantity"]').val(), 10);
      var selected_variant_id = parseInt($(this).find('.byos-product-item-checkbox').attr('selected_variant_id'));

      if (quantity > 0 && selected_variant_id && $(this).find('.byos-product-item-checkbox').is(':checked')) {
        items.push({
          quantity: quantity,
          id: selected_variant_id,
          properties: {
            '_type': 'byos',
            '_bundleid': randomId
          }
        });
      }
    });

    console.log('items',items);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({ items: items }), // ✅ Convert to JSON
      contentType: 'application/json',
      dataType: 'json', // ✅ ensure jQuery parses response correctly
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      },
      success: function() {
        $.getJSON("/cart.js", function (cart) {
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: { cart }
          })); 
        });
        document.getElementById('mini-cart').open = true;
        $(_this).removeAttr('disabled');
        $(_this).removeAttr('aria-busy');
        $(_this).parents('.modal').removeAttr('open');
        console.log('success');
      }
    });
  });

  $('.byos-modal-opner').click(function(){
    var modal_id = $(this).attr('byos_modal_id');
    $(`#${modal_id}`).attr('open','open');
    $('.byos-product-item').removeClass('hilighted');
  });
  $('.byos-media_dot').click(function(){
    $('.byos-product-item').removeClass('hilighted');
    var modal_id = $(this).attr('byos_modal_id');
    var product_id = $(this).attr('byos_media_dot_id');
    $(`#${modal_id}`).attr('open','open');

    setTimeout(() => {      
      $(`.byos-product-item[byos_product_id="${product_id}"]`).addClass('hilighted');
    }, 200);
    
  });
  $('.byos-preview-items-media-item').click(function(){
    $('.byos-product-item').removeClass('hilighted');
    var modal_id = $(this).attr('byos_modal_id');
    var product_id = $(this).attr('byos_preview_item_id');
    $(`#${modal_id}`).attr('open','open');
    
    setTimeout(() => {
      console.log('product_id',product_id,$(`.byos-product-item[byos_product_id="${product_id}"]`).length);
      $(`.byos-product-item[byos_product_id="${product_id}"]`).addClass('hilighted');
    }, 200);
  });

  $("body").on("click", ".byos-dicount-btn", function () {
    var copy_text = $(this);
    var text = $(this).attr('data-code');
    var $temp = $("<input>");

    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html("Copied");
    setTimeout(function () {
      copy_text.html("Copy");
    }, 1000);
  });
});